import { render } from "./CommentRespond.vue?vue&type=template&id=07f81b8d&scoped=true"
import script from "./CommentRespond.vue?vue&type=script&lang=js"
export * from "./CommentRespond.vue?vue&type=script&lang=js"

import "./CommentRespond.vue?vue&type=style&index=0&id=07f81b8d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07f81b8d"

export default script